import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { obtenerMesActual } from "../utils/categoriasConEmoji";

import Layout from "../layout/Layout";
import { useEffect, useState } from "react";
export default function AddSalario() {

  const [mes, setMes] = useState(obtenerMesActual);
  const [salario, setSalario] = useState([]);
  const getList = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/salarios/list?mes=${mes}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );

    if (res.data.success) {
      setSalario(res.data.data);

    } else {
      alert("Error al obtener gastos");
    }
  }
  useEffect(() => {
    getList();
  }, [mes])

  const formik = useFormik({
    initialValues: {
      mes: "",
      quincena: "1",
      monto: ""
    },
    validationSchema: Yup.object({
      mes: Yup.string()
        .required("Selecciona el mes"),
      quincena: Yup.string()
        .oneOf(["1", "2"], "Selecciona 1 o 2")
        .required("Selecciona la quincena"),
      monto: Yup.number()
        .min(1, "Debe ser mayor a 0")
        .required("Monto requerido"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/salarios`,
          {
            mes: values.mes,
            quincena: parseInt(values.quincena),
            monto: parseFloat(values.monto),
          },
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );

        if (res.data.success) {
          alert("Salario guardado 🎉");
          resetForm();
        } else {
          alert("No se pudo guardar el salario 😢");
        }
      } catch (error) {
        console.error(error);
        alert("Error de conexión");
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <Layout>
      <div className="container text-center">
        <div className="row">
          <div className="col">

            <div className="div-card">
              <h4>Agregar salario quincenal</h4>
              <form onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Mes:</label>
                  <input
                    type="month"
                    name="mes"
                    className="form-control"
                    value={formik.values.mes}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.mes && formik.errors.mes && (
                    <p style={{ color: "red" }}>{formik.errors.mes}</p>
                  )}
                </div>

                <div>
                  <label className="form-label">Quincena:</label>
                  <select
                    name="quincena"
                    className="form-control"
                    value={formik.values.quincena}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="1">Primera (1)</option>
                    <option value="2">Segunda (2)</option>
                  </select>
                  {formik.touched.quincena && formik.errors.quincena && (
                    <p style={{ color: "red" }}>{formik.errors.quincena}</p>
                  )}
                </div>

                <div>
                  <label className="form-label">Monto:</label>
                  <input
                    type="number"
                    className="form-control"
                    name="monto"
                    value={formik.values.monto}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.monto && formik.errors.monto && (
                    <p style={{ color: "red" }}>{formik.errors.monto}</p>
                  )}
                </div>

                <button className="btn btn-warning" type="submit" disabled={formik.isSubmitting}>
                  {formik.isSubmitting ? "Guardando..." : "Guardar salario"}
                </button>
              </form>
            </div>
          </div>

          <div className="col">
            <div className="div-card">

              <label>Selecciona mes: </label>
              <input
                type="month"
                value={mes}
                className="form-control"
                onChange={(e) => setMes(e.target.value)}
              />
              {
                (salario.length === 0) ?
                  <>No hay nada</>
                  :
                  (
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">mes</th>
                          <th scope="col">quincena</th>
                          <th scope="col">monto</th>
                        </tr>
                      </thead>
                      <tbody>

                        {
                          salario.map((item, index) => {
                            return (
                              <tr key={`extra-${index}`}>
                                <td >{item.mes}</td>
                                <td>{item.quincena}</td>
                                <td>{item.monto}</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  )
              }
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
